import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import LoginPage from '../pages/login';
import Awaiting from "../pages/awaiting/awaiting";
import ForgotPassword from '../pages/forgotPassword';
import ResetPassword from '../pages/resetPassword';
import ResetPasswordDisable from '../pages/resetPasswordDisable';
import Signup from '../pages/signup';
import FinishSignupPage from '../pages/finishSignup';
import {isTest} from "../util/constants";
import { SuccessElement } from '../util/testing-utils';
import {AnimatePresence} from "framer-motion";
import {useLocation} from "react-router";
import FailedVerifyEmailPage from "../pages/verifyEmail/failedVerifyEmail";
import SuccessVerifyEmailPage from "../pages/verifyEmail/SuccessVerifyEmail";
import Alert from "../pages/alert";

export enum Routes {
  LOGIN = '/login',
  SIGNUP = '/signup',
  FINISH_SIGNUP = '/finish-signup',
  TESTING_SUCCESS = '/success-test',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password',
  RESET_PASSWORD_DISABLE = '/reset-password-disable',
  AWAITING = '/awaiting',
  SUCCESS_VERIFY_EMAIL = '/email-verification/',
  FAILED_VERIFY_EMAIL = '/email-verification/error',
  ALERT = '/alert'
}

const Routing = () => {

  const location = useLocation();

  return (
    <AnimatePresence exitBeforeEnter>
      <Switch location={location} key={location.pathname}>
        <Route path={Routes.LOGIN} component={LoginPage}/>
        <Route path={Routes.SIGNUP} component={Signup}/>
        <Route path={Routes.FORGOT_PASSWORD} component={ForgotPassword}/>
        <Route path={Routes.RESET_PASSWORD_DISABLE} component={ResetPasswordDisable}/>
        <Route path={Routes.RESET_PASSWORD} component={ResetPassword}/>
        <Route path={Routes.FINISH_SIGNUP} component={FinishSignupPage}/>
        <Route path={Routes.AWAITING} component={Awaiting}/>
        <Route path={Routes.FAILED_VERIFY_EMAIL} component={FailedVerifyEmailPage}/>
        <Route path={Routes.SUCCESS_VERIFY_EMAIL} component={SuccessVerifyEmailPage}/>
        <Route path={Routes.ALERT} component={Alert}/>
        {isTest && <Route path={Routes.TESTING_SUCCESS} component={SuccessElement}/>}
        {/** all other routes following /authenticate will redirect to login page **/}
        <Route path='/*'>
          <Redirect to={Routes.LOGIN} />
        </Route>
      </Switch>
    </AnimatePresence>
  )
}

export default Routing;
